export default __webpack_public_path__ + "static/media/house.980fe57d.svg";